<app-cookie-consent-banner></app-cookie-consent-banner>

<div class="footer-info">{{ version }}</div>
